import { classNameMerger } from '@breetometer/utils';
import type { ReactNode } from 'react';

export const LoadingComponent = ({
	loading,
	children,
	text,
	shape = 'default',
	max,
	dark,
}: {
	children?: ReactNode;
	loading: boolean;
	text?: string;
	shape?: 'circle' | 'default';
	max?: boolean;
	dark?: boolean;
}) => (
	<>
		{loading ? (
			<div className={classNameMerger('global-skeleton', shape, max && 'max', dark && 'dark')}>{text ?? 'loading...'}</div>
		) : (
			children
		)}
	</>
);
